import { createContext } from 'react';

interface Context {
  open: boolean;
  setOpen: (open: boolean) => void;
  tab?: string;
  setTab?: (tab: string) => void;
}

export const ActivityItemContext = createContext<Context>({
  open: false,
  setOpen: () => {},
  tab: undefined,
  setTab: () => {},
});
